

function Header() {


    return (
        <div className="header-container">
            <h1>Gift Drag & Drop</h1>
            <div className="direction-container">
                <h3>🎁 Drag the gifts to place them under the christmas tree</h3>
                <h3>🎁 Click the Christmas tree to reset the gifts</h3>
            </div>
        </div>
    )
}

export default Header;